import { el, toggleVisibility } from './dom.js';
import { computeStats, formatCompact, getTopDomains } from '../utils/stats.js';
import { formatRelative } from '../utils/dates.js';

/**
 * Pannelli derivati dai dati: barra delle statistiche e classifica delle fonti.
 * Il calcolo vive in `utils/stats.js`; qui si disegna soltanto.
 */

/**
 * Aggiorna i quattro contatori in cima alla pagina.
 *
 * @param {HTMLElement|null} root contenitore con gli elementi `[data-stat]`
 * @param {Array<object>} stories
 * @param {Date} [now]
 */
export function renderStats(root, stories, now = new Date()) {
  if (!root) return;

  const { total, avgScore, totalComments, freshest } = computeStats(stories);

  const values = {
    total: total ? formatCompact(total) : '—',
    avgScore: total ? String(avgScore).replace('.', ',') : '—',
    totalComments: total ? formatCompact(totalComments) : '—',
    freshest: freshest ? formatRelative(freshest, now) : '—',
  };

  for (const [key, value] of Object.entries(values)) {
    const node = root.querySelector(`[data-stat="${key}"]`);
    if (node) node.textContent = value;
  }
}

/**
 * Disegna la classifica dei domini più citati (barre proporzionali).
 *
 * @param {HTMLElement|null} root sezione `.domains`
 * @param {Array<object>} stories
 * @param {number} [limit=5]
 */
export function renderTopDomains(root, stories, limit = 5) {
  if (!root) return;

  const list = root.querySelector('[data-domains-list]');
  const domains = getTopDomains(stories, limit);

  // Con meno di due fonti distinte la classifica non dice nulla: si nasconde.
  toggleVisibility(root, domains.length > 1);
  if (!list) return;

  list.replaceChildren(
    ...domains.map((entry) =>
      el('li', { class: 'domain-row' }, [
        el('span', { class: 'domain-row__name', text: entry.domain, title: entry.domain }),
        el('span', { class: 'domain-row__bar' }, [
          el('span', { class: 'domain-row__fill', style: `width:${entry.percentage}%` }),
        ]),
        el('span', {
          class: 'domain-row__count',
          text: entry.count === 1 ? '1 news' : `${entry.count} news`,
        }),
      ]),
    ),
  );
}
